import AvailablePaymentMethods from './AvailablePaymentMethods';

export default AvailablePaymentMethods;
